import { defineMessages } from 'react-intl'

export const networkClaimMessages = defineMessages({
  whereCodeButtonText: {
    id: 'networkClaimMessages.whereCodeButtonText',
    description: 'Text for button to show QR code location',
    defaultMessage: 'Where can I find my code?',
  },
  claimManually: {
    id: 'networkClaimMessages.claimManually',
    description: 'Main text claim manually',
    defaultMessage: 'Claim Devices Manually',
  },
  scanQR: {
    id: 'networkClaimMessages.scanQR',
    description: 'Text to scan qr code',
    defaultMessage: 'Scan QR Code on the Smart Network Device',
  },
  claimDevices: {
    id: 'networkClaimMessages.claimDevices',
    description: 'Title for Claim Devices',
    defaultMessage: 'Claim Devices',
  },
  scanQRTitle: {
    id: 'networkClaimMessages.scanQRTitle',
    description: 'Title for Scan QR Code',
    defaultMessage: 'Scan QR Code',
  },
  popupTitle: {
    id: 'networkClaimMessages.popupTitle',
    description: 'Title for helper popup',
    defaultMessage: 'QR Code Location',
  },
})
